import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  HStack,
  VStack,
} from '@shared/ui';

export function StackShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.layout.stack.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.layout.stack.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <VStack gap="md">
          <HStack gap="sm">
            <div className="h-9 w-9 rounded-md bg-primary/20" />
            <div className="h-9 w-16 rounded-md bg-primary/30" />
            <div className="h-9 w-24 rounded-md bg-primary/40" />
          </HStack>
          <VStack gap="sm">
            <div className="h-8 w-full rounded-md bg-secondary/60" />
            <div className="h-8 w-4/5 rounded-md bg-secondary/70" />
            <div className="h-8 w-3/5 rounded-md bg-secondary/80" />
          </VStack>
        </VStack>
      </CardContent>
    </Card>
  );
}
